import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)

// Ready translated locale messages
export const messages = {
  es: {
    paymentComponent: {
      paymentMethodTitle: 'La manera más sencilla de pagar',
      selectPaymentMethodTitle: 'Seleccione el medio de pago',
      errorMessage: {
        ERR_PAYED: {
          title: 'El pago ya fue registrado',
          message: 'Su pago ya fue registrado, gracias por su compra.'
        },
        ERR_HASH_EXPIRED: {
          title: 'El tiempo de sesión ha expirado',
          message: 'Su tiempo de sesión de pago ha expirado. Por favor presione el botón de regresar a la tienda.'
        },
        ERR_SESSION_EXPIRED: {
          title: 'El tiempo de sesión ha expirado',
          message: 'Su tiempo de sesión de pago ha expirado. Por favor presione el botón de regresar a la tienda.'
        },
        ERR_NO_METHODS: {
          title: 'No hay medios de pagos disponibles',
          message: 'Desafortunadamente, la sesión de pago no tiene asociado ningún medio de pago.'
        },
        ERR_METHODS: {
          title: 'No hay medios de pagos disponibles',
          message: 'Desafortunadamente, la sesión de pago no cuenta con métodos de pagos disponible.'
        }
      },
      paymentMethodAlert: 'Para pagos que no sean con Tarjeta Crédito/Débito, el proceso será seguro en una ventana externa y luego volverás a nuestra tienda.',
      errorBackButton: 'Regresar a la tienda',
      backButton: 'Volver atrás',
      cardsAcceptedTitle: 'Tarjetas aceptadas'
    },
    yunoComponent: {
      errorMessage: {
        ERR_YUNO_METHOD: {
          title: 'El medio de pago no está disponible',
          message: 'Hubo un error, te sugerimos intentar con otro medio de pago.'
        },
        ERR_BINES_VALIDATION: {
          title: 'La tarjeta ingresada no es válida',
          message: 'La tarjeta ingresada no coincide con la promoción seleccionada en la tienda.'
        },
        ERR_BINES_FAILED: {
          title: 'La promoción no pudo ser validada',
          message: 'No se pudo validar si la tarjeta ingresada puede acceder a la promoción seleccionada en la tienda.'
        },
        ERR_PAYED: {
          title: 'El pago ya fue registrado',
          message: 'Su pago ya fue registrado, gracias por su compra.'
        }
      },
      errorBackButton: 'Regresar a la tienda',
      processorName: 'es', // En la BD se guarda el nombre variable (Nombre_Procesador)
      processorLegend: 'es',
      overlayMessage: {
        loading: 'Cargando, espere por favor',
        redirectionProcessor: 'Lo estamos redirigiendo al método de pago seleccionado, espere por favor',
        redirectionStore: 'Lo estamos redirigiendo a la tienda, espere por favor'
      }
    },
    paymeComponent: {
      processorName: 'es', // En la BD se guarda el nombre variable (Nombre_Procesador)
      processorLegend: 'es',
      overlayMessage: {
        loading: 'Cargando, espere por favor'
      }
    },
    incognitoModeComponent: {
      title: 'Pago no disponible en modo Incógnito',
      message: 'Lo sentimos, pero el pago en Modo Incógnito no está disponible en este momento. Por favor, intenta realizar tu compra nuevamente en modo normal de navegación.'
    }
  },
  en: {
    paymentComponent: {
      paymentMethodTitle: 'The easiest way to pay',
      selectPaymentMethodTitle: 'Select the payment method',
      errorMessage: {
        ERR_PAYED: {
          title: 'The payment has already been registered',
          message: 'Your payment has been registered, thank you for your purchase.'
        },
        ERR_HASH_EXPIRED: {
          title: 'The session time has expired',
          message: 'Your payment session has expired. Please press the button to return to the store.'
        },
        ERR_SESSION_EXPIRED: {
          title: 'The session time has expired',
          message: 'Your payment session has expired. Please press the button to return to the store.'
        },
        ERR_NO_METHODS: {
          title: 'There are no payment methods available',
          message: 'Unfortunately, the payment session does not have any payment method associated with it.'
        },
        ERR_METHODS: {
          title: 'There are no payment methods available',
          message: 'Unfortunately, the payment session does not have any payment methods available.'
        }
      },
      paymentMethodAlert: 'For payments other than Credit/Debit Cards, the process will be secure in an external window and then you will return to our store.',
      errorBackButton: 'Back to the store',
      backButton: 'Go back',
      cardsAcceptedTitle: 'Cards accepted'
    },
    yunoComponent: {
      errorMessage: {
        ERR_YUNO_METHOD: {
          title: 'The payment method is not available',
          message: 'There was an error, try again with another payment method.'
        },
        ERR_BINES_VALIDATION: {
          title: 'The card entered is not valid',
          message: 'The entered card does not match the selected promotion in the store.'
        },
        ERR_BINES_FAILED: {
          title: 'The promotion could not be validated',
          message: 'Could not validate if the entered card can access the selected promotion in the store.'
        }
      },
      errorBackButton: 'Back to the store',
      processorName: 'en', // En la BD se guarda el nombre variable (Nombre_Procesador)
      processorLegend: 'en',
      overlayMessage: {
        loading: 'Loading, please wait',
        redirectionProcessor: 'We are redirecting you to the selected payment method, please wait',
        redirectionStore: 'We are redirecting you to the store, please wait'
      }
    },
    paymeComponent: {
      processorName: 'en', // En la BD se guarda el nombre variable (Nombre_Procesador)
      processorLegend: 'en',
      overlayMessage: {
        loading: 'Loading, please wait'
      }
    },
    incognitoModeComponent: {
      incognitoModeMessage: 'We are sorry, but payment in Incognito Mode is not available at the moment. Please try making your purchase again in regular browsing mode.'
    }
  }
}

// Create VueI18n instance with options
export default new VueI18n({
  locale: 'es', // set locale
  fallbackLocale: 'es',
  messages // set locale messages
})
